const trimSlashes = (path?: string) => (path || '').replace(/^\/+|\/+$/g, '');

const decodePathSegment = (segment: string) => {
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
};

export function matchLinkedPath(
  configuredPath?: string,
  actualPath?: string,
): Record<string, string> | undefined {
  const configuredSegments = trimSlashes(configuredPath).split('/');
  const actualSegments = trimSlashes(actualPath).split('/');

  if (
    !configuredSegments[0] ||
    !actualSegments[0] ||
    configuredSegments.length !== actualSegments.length
  ) {
    return;
  }

  const pathParams: Record<string, string> = {};

  for (let index = 0; index < configuredSegments.length; index += 1) {
    const configuredSegment = configuredSegments[index];
    const actualSegment = actualSegments[index];

    if (configuredSegment.startsWith(':')) {
      const paramName = configuredSegment.slice(1);
      if (!paramName || !actualSegment) {
        return;
      }
      pathParams[paramName] = decodePathSegment(actualSegment);
      continue;
    }

    if (configuredSegment.toLowerCase() !== actualSegment.toLowerCase()) {
      return;
    }
  }

  return pathParams;
}
